import NotificationLabel from './NotificationLabel';
export { NotificationLabel };
export default NotificationLabel;
